import React, { useState, useEffect, Fragment } from "react";
import PropTypes from "prop-types";
import { NavDropdown, ListGroup, Accordion, Card, Button } from "react-bootstrap";
import NavbarLink from "./NavbarLink";
import { ListIcon } from "../Icon";
const Orders = ({ CanI }) => {
    const [state, setState] = useState({
        orders_add: false,
        orders_request: false,
        order_line_items_view: false,
        order_line_items_view_requested: false,
        order_line_items_view_ordered: false
    });

    useEffect(() => {
        async function InitOrders() {
            setState({
                ...state,
                orders_add: await CanI("orders_add"),
                orders_request: await CanI("orders_request"),
                order_line_items_view: await CanI("order_line_items_view"),
                order_line_items_view_requested: await CanI("order_line_items_view_requested"),
                order_line_items_view_ordered: await CanI("order_line_items_view_ordered")
            });
        }
        InitOrders();
    }, []);
    const {
        orders_request,
        orders_add,
        order_line_items_view,
        order_line_items_view_requested,
        order_line_items_view_ordered
    } = state;
    return (
        <NavDropdown.ItemText>
            <ListGroup>
                <ListGroup.Item>
                    <NavbarLink to="/app/orders" className="dropdown-item" label={`View Orders`} />
                </ListGroup.Item>

                {orders_add && (
                    <ListGroup.Item>
                        <NavbarLink
                            className="dropdown-item"
                            to="/app/orders/add"
                            label="Add Order"
                        />
                    </ListGroup.Item>
                )}
                {orders_request && (
                    <ListGroup.Item>
                        <NavbarLink
                            className="dropdown-item"
                            to="/app/orders/request"
                            label={`Request Order`}
                        />
                    </ListGroup.Item>
                )}
            </ListGroup>

            <Accordion>
                {order_line_items_view && (
                    <Card>
                        <Card.Header>
                            <Accordion.Toggle
                                as={Button}
                                variant="light"
                                eventKey="order-line-items-toggle-list"
                            >
                                <span className="text-dark" id={"order-line-items-toggle-list"}>
                                    <ListIcon width={17} height={17} /> Order Line Items
                                </span>
                            </Accordion.Toggle>
                        </Card.Header>

                        <Accordion.Collapse eventKey="order-line-items-toggle-list">
                            <Card.Body className="p-0">
                                <ListGroup>
                                    <ListGroup.Item>
                                        <NavbarLink
                                            to="/app/orders/line_items"
                                            className="dropdown-item"
                                            label={`View`}
                                        />
                                    </ListGroup.Item>

                                    {order_line_items_view_requested && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/app/orders/line_items/requested"
                                                className="dropdown-item"
                                                label={`Requested`}
                                            />
                                        </ListGroup.Item>
                                    )}

                                    {order_line_items_view_ordered && (
                                        <ListGroup.Item>
                                            <NavbarLink
                                                to="/app/orders/line_items/ordered"
                                                className="dropdown-item"
                                                label={`Ordered`}
                                            />
                                        </ListGroup.Item>
                                    )}
                                </ListGroup>
                            </Card.Body>
                        </Accordion.Collapse>
                    </Card>
                )}
            </Accordion>
        </NavDropdown.ItemText>
    );
};

Orders.propTypes = { CanI: PropTypes.func };

export default Orders;
